module.exports = __webpack_public_path__ + "static/media/qr_code_recycling_extra_rewards.5b31f392.png";